import React, { useEffect } from 'react'
import Select from "react-select";
import { selectStylesFilter } from '../../utils';

const FilterSelect = ({ label_text, options, state, setState, isDisabled, isMulti, placeholder, disableClearable, styleFunction }) => {
    const handleChange = (value) => {
        if (!value) {
            setState("")
        } else {
            setState(value)
        }
    }

    return (
        <div className=' z-10 w-full'>
            <span className="text-xs font-medium mb-1 block">
                {label_text}
            </span>

            <Select
                placeholder={placeholder}
                isDisabled={isDisabled}
                styles={styleFunction ? styleFunction(state ? true : false) : selectStylesFilter(state ? true : false) }
                options={options}
                onChange={value => handleChange(value)}
                value={state}
                isMulti={isMulti}
                isClearable={disableClearable ? false : true}
            />
        </div>
    )
}

export default FilterSelect